<template>
  <Padding :padding="padding">
    <ButtonRow
      v-if="buttonRow"
      v-bind="buttonRow"
    >
    </ButtonRow>
  </Padding>
</template>

<script lang="ts" setup>
import ButtonRow from '~/components/Atoms/ButtonRow/ButtonRow.vue';
import Padding from '~/components/Atoms/Padding/Padding.vue';
import type { PortableTextButtonRow } from '~/sanity/types';
defineProps<PortableTextButtonRow>();
</script>

<style></style>
